import { AppBar } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomToolbar from "./CustomToolbar";

const drawerWidth = 270;
const closedDrawerWidth = 65;

const CustomAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: `calc(100% - ${open ? drawerWidth : closedDrawerWidth}px)`, // Adjust width based on Drawer state
  marginLeft: open ? drawerWidth : 0, // Adjust marginLeft based on Drawer state
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Topbar = ({ routes, open }) => {
  return (
    <CustomAppBar position="fixed" open={open}>
      <CustomToolbar routes={routes} className="h-full" />
    </CustomAppBar>
  );
};

export default Topbar;
